<!-- Header -->
<div class="flex items-center justify-between mb-6 flex-wrap gap-3">
  <div>
    <h2 class="text-xl font-bold text-gray-900">Members</h2>
    <p class="text-sm text-gray-500 mt-0.5">Tenant members assigned across all committees</p>
  </div>
  <div class="flex items-center gap-2">
    @if (isSuperAdmin()) {
      <button type="button" (click)="showRecycleBin.set(true)" title="View deleted members"
              class="flex items-center gap-2 bg-white border border-gray-300 text-gray-600 hover:text-blue-600 hover:border-blue-300 text-sm font-medium px-3 py-2 rounded-lg transition-colors shadow-sm">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7h16M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2m-7 4l1 7m4-7l-1 7M5 7l1 12a2 2 0 002 2h8a2 2 0 002-2l1-12"/>
        </svg>
        <span class="hidden sm:inline">Recycle bin</span>
      </button>
    }
    <ng-container *appHasPermission="201">
      <button (click)="openCreate()"
              class="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors shadow-sm">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
        </svg>
        Add Member
      </button>
    </ng-container>
  </div>
</div>

@if (isSuperAdmin()) {
  <app-recycle-bin-modal
    [open]="showRecycleBin()"
    entityKey="members"
    title="Members"
    (restored)="loadMembers()"
    (close)="showRecycleBin.set(false)"
  ></app-recycle-bin-modal>
}

@if (!hasBuSelected()) {
  <app-no-bu-selected entityLabel="members" />
} @else {

<!-- Period + KPI strip -->
<div class="bg-gradient-to-br from-white to-blue-50/40 border border-blue-100 rounded-2xl shadow-sm p-4 mb-4">
  <div class="flex items-center justify-between flex-wrap gap-3 mb-4">
    <div class="flex items-center gap-2">
      <span class="text-xs font-semibold uppercase tracking-wider text-gray-500">Fee period</span>
      <div class="inline-flex items-center gap-1 bg-white border border-gray-200 rounded-lg shadow-sm">
        <button type="button" (click)="shiftFeePeriod(-1)" title="Previous month"
                class="p-1.5 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-l-lg">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg>
        </button>
        <select [(ngModel)]="feeMonth" (ngModelChange)="setFeePeriod(feeMonth, feeYear)"
                class="border-0 bg-white px-2 py-1.5 text-sm font-medium text-gray-800 focus:outline-none">
          <option *ngFor="let m of months" [ngValue]="m.value">{{ m.name }}</option>
        </select>
        <select [(ngModel)]="feeYear" (ngModelChange)="setFeePeriod(feeMonth, feeYear)"
                class="border-0 border-l border-gray-200 bg-white px-2 py-1.5 text-sm font-medium text-gray-800 focus:outline-none">
          <option *ngFor="let y of feeYears" [ngValue]="y">{{ y }}</option>
        </select>
        <button type="button" (click)="shiftFeePeriod(1)" title="Next month"
                class="p-1.5 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-r-lg">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
        </button>
      </div>
      @if (!isCurrentPeriod()) {
        <button (click)="goToCurrentPeriod()" class="text-xs text-blue-700 hover:underline">Jump to current</button>
      }
    </div>

    <!-- Fee filter chips -->
    <div class="inline-flex rounded-lg border border-gray-200 bg-white shadow-sm overflow-hidden text-sm">
      <button (click)="setFeeFilter('')"
              [class]="feeFilter === ''
                ? 'px-3 py-1.5 bg-gray-900 text-white font-medium'
                : 'px-3 py-1.5 text-gray-700 hover:bg-gray-50'">
        All
      </button>
      <button (click)="setFeeFilter('paid')"
              [class]="feeFilter === 'paid'
                ? 'px-3 py-1.5 bg-green-600 text-white font-medium border-l border-gray-200'
                : 'px-3 py-1.5 text-gray-700 hover:bg-gray-50 border-l border-gray-200'">
        Paid
      </button>
      <button (click)="setFeeFilter('pending')"
              [class]="feeFilter === 'pending'
                ? 'px-3 py-1.5 bg-amber-500 text-white font-medium border-l border-gray-200'
                : 'px-3 py-1.5 text-gray-700 hover:bg-gray-50 border-l border-gray-200'">
        Pending
      </button>
      <button (click)="setFeeFilter('inactive')"
              [class]="feeFilter === 'inactive'
                ? 'px-3 py-1.5 bg-gray-600 text-white font-medium border-l border-gray-200'
                : 'px-3 py-1.5 text-gray-700 hover:bg-gray-50 border-l border-gray-200'">
        Inactive
      </button>
    </div>
  </div>

  <!-- KPI cards -->
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
    <div class="bg-white rounded-xl border border-green-100 px-4 py-3">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-xs font-medium text-gray-500">Paid this period</p>
          <p class="text-xl font-bold text-gray-900 mt-1">
            {{ feeSummary?.paidCount ?? 0 }}<span class="text-sm text-gray-400 font-normal"> / {{ feeSummary?.totalActiveMembers ?? 0 }}</span>
          </p>
          <p class="text-xs text-green-700 mt-0.5 font-medium">Rs. {{ (feeSummary?.totalCollected ?? 0) | number:'1.2-2' }}</p>
        </div>
        <div class="w-10 h-10 rounded-xl bg-green-50 text-green-600 flex items-center justify-center">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-xl border border-amber-100 px-4 py-3">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-xs font-medium text-gray-500">Outstanding</p>
          <p class="text-xl font-bold text-gray-900 mt-1">
            {{ feeSummary?.outstandingMembers ?? 0 }}<span class="text-sm text-gray-400 font-normal"> member(s)</span>
          </p>
          <p class="text-xs text-amber-700 mt-0.5 font-medium">Rs. {{ (feeSummary?.outstandingAmount ?? 0) | number:'1.2-2' }}</p>
        </div>
        <div class="w-10 h-10 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        </div>
      </div>
      @if (isAdmin() && (feeSummary?.outstandingMembers ?? 0) > 0) {
        <button type="button"
                (click)="openFeeReminder()"
                [disabled]="isSendingReminder"
                class="mt-2 w-full inline-flex items-center justify-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-amber-50 text-amber-800 border border-amber-200 rounded-md hover:bg-amber-100 disabled:opacity-50">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
          </svg>
          Send Reminders
        </button>
      }
    </div>

    @if (showFeeReminderPanel) {
      <div class="sm:col-span-3 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3">
        <div class="flex items-start gap-4 flex-wrap">
          <div class="flex-1 min-w-[260px]">
            <p class="text-sm font-medium text-gray-900 mb-2">
              Send reminders for {{ monthLabel(feeMonth) }} {{ feeYear }} to {{ feeSummary?.outstandingMembers ?? 0 }} member(s)?
            </p>
            <div class="flex gap-4">
              <label class="inline-flex items-center gap-1.5 text-sm text-gray-700">
                <input type="checkbox" [(ngModel)]="reminderChannels.email" name="frEmail" class="rounded text-amber-600 focus:ring-amber-500"/>
                Email
              </label>
              <label class="inline-flex items-center gap-1.5 text-sm text-gray-700">
                <input type="checkbox" [(ngModel)]="reminderChannels.sms" name="frSms" class="rounded text-amber-600 focus:ring-amber-500"/>
                SMS
              </label>
            </div>
            <div *ngIf="reminderError" class="mt-2 text-xs text-red-600">{{ reminderError }}</div>
            <div *ngIf="reminderMessage" class="mt-2 text-xs text-green-700">{{ reminderMessage }}</div>
          </div>
          <div class="flex items-center gap-2">
            <button type="button" (click)="cancelFeeReminder()" [disabled]="isSendingReminder"
                    class="px-3 py-1.5 text-xs font-medium bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 disabled:opacity-50">
              Cancel
            </button>
            <button type="button" (click)="sendFeeReminder()" [disabled]="isSendingReminder"
                    class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-amber-600 text-white rounded-md hover:bg-amber-700 disabled:opacity-50">
              @if (isSendingReminder) { <app-spinner size="xs" colour="white"></app-spinner> }
              {{ isSendingReminder ? 'Sending…' : 'Send' }}
            </button>
          </div>
        </div>
      </div>
    }
    <div class="bg-white rounded-xl border border-blue-100 px-4 py-3">
      <div>
        <div class="flex items-center justify-between">
          <p class="text-xs font-medium text-gray-500">Collection rate</p>
          <span class="text-xs font-semibold text-blue-700">{{ collectionRate }}%</span>
        </div>
        <div class="mt-3 h-2 bg-blue-50 rounded-full overflow-hidden">
          <div class="h-full bg-gradient-to-r from-blue-500 to-blue-600 transition-all" [style.width.%]="collectionRate"></div>
        </div>
        <p class="text-xs text-gray-400 mt-2">Active members in {{ monthLabel(feeMonth) }} {{ feeYear }}</p>
      </div>
    </div>
  </div>
</div>

<!-- Scope tabs -->
<div class="flex items-center justify-between mb-4 flex-wrap gap-3">
  @if (canSwitchScope()) {
    <div class="max-w-full overflow-x-auto">
    <div class="inline-flex rounded-lg border border-gray-300 overflow-hidden text-sm bg-white whitespace-nowrap">
      <button type="button" (click)="setScope('assigned')"
              [class]="scope() === 'assigned'
                ? 'px-3 py-1.5 bg-blue-600 text-white font-medium'
                : 'px-3 py-1.5 text-gray-700 hover:bg-gray-50'">
        Assigned{{ selectedBuName() ? ' to ' + selectedBuName() : '' }}
      </button>
      <button type="button" (click)="setScope('unassigned')"
              [class]="scope() === 'unassigned'
                ? 'px-3 py-1.5 bg-blue-600 text-white font-medium border-l border-gray-300'
                : 'px-3 py-1.5 text-gray-700 hover:bg-gray-50 border-l border-gray-300'">
        Not assigned
      </button>
      <button type="button" (click)="setScope('all')"
              [class]="scope() === 'all'
                ? 'px-3 py-1.5 bg-blue-600 text-white font-medium border-l border-gray-300'
                : 'px-3 py-1.5 text-gray-700 hover:bg-gray-50 border-l border-gray-300'">
        All members
      </button>
    </div>
    </div>
  } @else {
    <div class="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-gray-100 text-gray-600 text-sm">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>
      Viewing all tenant members
    </div>
  }
</div>

<!-- Filters -->
<div class="bg-white rounded-xl border border-gray-100 shadow-sm p-4 mb-4">
  <div class="flex flex-col md:flex-row gap-3">
    <div class="relative flex-1">
      <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
      </svg>
      <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()"
             placeholder="Search by name, NIC, phone or email..."
             class="w-full pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"/>
    </div>
    <select [(ngModel)]="filterStatus" (ngModelChange)="onFilterChange()"
            class="border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none md:w-48">
      <option value="">All statuses</option>
      <option value="Active">Active</option>
      <option value="Inactive">Inactive</option>
      <option value="Left">Left</option>
    </select>
  </div>
</div>

<!-- Bulk toolbar -->
@if (selectedCount() > 0) {
  <div class="bg-blue-50 border border-blue-200 rounded-xl px-4 py-3 mb-4 flex items-center justify-between flex-wrap gap-3 sticky top-0 z-10">
    <div class="flex items-center gap-3 text-sm">
      <span class="font-semibold text-blue-900">{{ selectedCount() }} selected</span>
      <button (click)="clearSelection()" class="text-blue-700 hover:underline">Clear</button>
    </div>
    <div class="flex items-center gap-2 flex-wrap">
      <button *appHasPermission="301" (click)="openBulkPay()"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium rounded-lg shadow-sm">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        Collect payments…
      </button>
      <button *appHasPermission="203" (click)="openBulkAssign('add')"
              class="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg">
        Assign to committees…
      </button>
      <button *appHasPermission="203" (click)="openBulkAssign('remove')"
              class="px-3 py-1.5 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 text-sm font-medium rounded-lg">
        Remove from committees…
      </button>
    </div>
  </div>
}

<!-- Info / Error -->
@if (infoMessage) {
  <div class="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
    <svg class="w-5 h-5 text-blue-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
    </svg>
    <p class="text-sm text-blue-700 flex-1">{{ infoMessage }}</p>
    <button (click)="infoMessage = ''" class="text-blue-400 hover:text-blue-600">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  </div>
}

@if (errorMessage) {
  <div class="flex items-center gap-2 bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
    <svg class="w-5 h-5 text-red-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
    </svg>
    <p class="text-sm text-red-700 flex-1">{{ errorMessage }}</p>
    <button (click)="errorMessage = ''" class="text-red-400 hover:text-red-600">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  </div>
}

<!-- Loading -->
@if (isLoading) {
  <app-loader caption="Loading members…"></app-loader>
}

<!-- Table -->
@if (!isLoading) {
  <div class="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">

    <!-- Mobile card list -->
    <div class="md:hidden divide-y divide-gray-100">
      @for (member of members; track member.id) {
        <div class="p-4 space-y-3"
             [class.bg-blue-50]="isSelected(member.id)"
             [class.border-l-4]="isMissingCurrentBu(member)"
             [class.border-l-amber-400]="isMissingCurrentBu(member)">

          <div class="flex items-start gap-3">
            <input type="checkbox"
                   [checked]="isSelected(member.id)"
                   (change)="toggleSelect(member.id)"
                   class="mt-2.5 text-blue-600 rounded border-gray-300 focus:ring-blue-500 flex-shrink-0"/>
            <div class="w-10 h-10 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-xs font-semibold flex-shrink-0">
              {{ getInitials(member.fullName) }}
            </div>
            <div class="min-w-0 flex-1">
              <button type="button" (click)="openMemberDetail(member)"
                      class="font-medium text-gray-900 hover:text-blue-700 text-left leading-snug">
                {{ member.fullName }}
              </button>
              <div class="text-xs text-gray-500 truncate">
                {{ member.phone || member.email || member.nic }}
              </div>
              <div class="flex items-center gap-1.5 flex-wrap mt-1.5">
                <span class="inline-flex px-2 py-0.5 rounded-full text-xs font-medium" [class]="statusBadgeClass(member.status)">
                  {{ member.status }}
                </span>
                @if (member.userAccount && roleLabel(member); as rl) {
                  <span class="inline-flex px-2 py-0.5 rounded-full text-xs font-medium" [class]="roleBadgeClass(member)">
                    {{ rl }}
                  </span>
                }
                @if (isMissingCurrentBu(member)) {
                  <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-amber-50 text-amber-700 border border-amber-200">
                    Not in {{ selectedBuName() }}
                  </span>
                }
              </div>
            </div>
            <button (click)="openMemberDetail(member)"
                    title="Quick view"
                    [disabled]="rowBusyId === member.id"
                    class="tap-target inline-flex items-center justify-center p-2 -m-1 text-gray-400 hover:text-blue-600 rounded-lg transition-colors disabled:opacity-50 flex-shrink-0">
              @if (rowBusyId === member.id) {
                <app-spinner size="sm" colour="current"></app-spinner>
              } @else {
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                </svg>
              }
            </button>
          </div>

          <div class="flex items-center justify-between gap-2 flex-wrap pl-[3.75rem]">
            <div class="flex items-center gap-2 flex-wrap">
              <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium"
                    [class]="feeStatusBadgeClass(member)"
                    [title]="feeStatusTooltip(member)">
                {{ feeStatusLabel(member) }}
              </span>
              @if (member.status === 'Active' && (member.currentPeriodTotalPaid ?? 0) > 0) {
                <span class="text-xs text-gray-500">Rs. {{ member.currentPeriodTotalPaid | number:'1.2-2' }}</span>
              }
              @if (member.status === 'Active') {
                <button *appHasPermission="301" type="button" (click)="openPayForMember(member)"
                        [title]="feeStatusTooltip(member)"
                        class="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-md text-xs font-medium border transition-colors"
                        [class]="payButtonClass(member)">
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"/></svg>
                  {{ payButtonLabel(member) }}
                </button>
              }
            </div>
            <div class="flex items-center gap-1">
              @if (isAdmin() && isMissingCurrentBu(member)) {
                <button type="button"
                        (click)="confirmAssign(member)"
                        [disabled]="rowBusyId === member.id"
                        class="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-md text-xs font-semibold bg-blue-600 text-white hover:bg-blue-700 transition-colors disabled:opacity-60">
                  Assign
                </button>
              }
              <button *appHasPermission="203" (click)="openEdit(member)"
                      title="Edit"
                      class="tap-target inline-flex items-center justify-center p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                </svg>
              </button>
              <button *appHasPermission="204" (click)="confirmDelete(member)"
                      title="Delete"
                      class="tap-target inline-flex items-center justify-center p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      }
      @if (members.length === 0) {
        <div class="px-5 py-16 text-center">
          <div class="flex flex-col items-center gap-3 text-gray-400">
            <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
            <p class="text-sm">No members found</p>
            <button *appHasPermission="201" (click)="openCreate()"
                    class="text-blue-600 text-sm hover:underline">
              Add the first member
            </button>
          </div>
        </div>
      }
    </div>

    <!-- Desktop table -->
    <div class="hidden md:block overflow-x-auto">
      <table class="w-full text-sm">
        <thead class="bg-gray-50 border-b border-gray-100">
          <tr>
            <th class="w-10 px-4 py-3">
              <input type="checkbox"
                     [checked]="allOnPageSelected"
                     (change)="toggleSelectAllOnPage()"
                     class="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"/>
            </th>
            <th class="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Member</th>
            <th class="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Status</th>
            <th class="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Role</th>
            <th class="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Committees</th>
            <th class="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">
              Fee · {{ monthLabel(feeMonth) }} {{ feeYear }}
            </th>
            <th class="text-right px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200">
          @for (member of members; track member.id) {
            <tr class="odd:bg-white even:bg-gray-100 hover:bg-blue-100 transition-colors"
                [class.!bg-blue-200]="isSelected(member.id)"
                [class.border-l-4]="isMissingCurrentBu(member)"
                [class.border-l-amber-400]="isMissingCurrentBu(member)">
              <td class="px-4 py-3">
                <input type="checkbox"
                       [checked]="isSelected(member.id)"
                       (change)="toggleSelect(member.id)"
                       class="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"/>
              </td>
              <td class="px-5 py-3">
                <div class="flex items-center gap-3">
                  <div class="w-9 h-9 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-xs font-semibold">
                    {{ getInitials(member.fullName) }}
                  </div>
                  <div class="min-w-0">
                    <button type="button" (click)="openMemberDetail(member)"
                            class="font-medium text-gray-900 hover:text-blue-700 truncate text-left">
                      {{ member.fullName }}
                    </button>
                    <div class="text-xs text-gray-500 truncate">
                      {{ member.phone || member.email || member.nic }}
                    </div>
                  </div>
                </div>
              </td>
              <td class="px-5 py-3">
                <span class="inline-flex px-2 py-0.5 rounded-full text-xs font-medium" [class]="statusBadgeClass(member.status)">
                  {{ member.status }}
                </span>
              </td>
              <td class="px-5 py-3">
                @if (member.userAccount) {
                  <div class="flex flex-col gap-0.5">
                    @if (roleLabel(member); as rl) {
                      <span class="inline-flex w-fit px-2 py-0.5 rounded-full text-xs font-medium" [class]="roleBadgeClass(member)">
                        {{ rl }}
                      </span>
                    }
                    @if (member.userAccount.lastLoginDate) {
                      <span class="text-[11px] text-gray-500 leading-tight">
                        Last login:
                        <span class="font-semibold text-gray-700">{{ member.userAccount.lastLoginDate | date:'h:mm a' }}</span>
                        <span class="text-gray-400">· {{ member.userAccount.lastLoginDate | date:'MMM d, y' }}</span>
                      </span>
                    } @else {
                      <span class="text-[11px] text-gray-400 italic">Never logged in</span>
                    }
                  </div>
                } @else {
                  <span class="text-xs text-gray-400">No account</span>
                }
              </td>
              <td class="px-5 py-3">
                <div class="flex flex-wrap gap-1 max-w-xs">
                  @if (isMissingCurrentBu(member)) {
                    <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-amber-50 text-amber-700 border border-amber-200"
                          [title]="'Not assigned to ' + (selectedBuName() ?? 'this committee')">
                      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                      Not in {{ selectedBuName() }}
                    </span>
                  }
                  @if (member.businessUnitIds && member.businessUnitIds.length > 0) {
                    @for (buId of member.businessUnitIds; track buId) {
                      <span [class]="isCurrentBu(buId)
                              ? 'inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-blue-600 text-white'
                              : 'inline-flex px-2 py-0.5 rounded-full text-xs font-medium border border-gray-300 text-gray-600'">
                        {{ buName(buId) }}
                      </span>
                    }
                  } @else if (!isMissingCurrentBu(member)) {
                    <span class="text-xs text-gray-400">—</span>
                  }
                </div>
              </td>
              <td class="px-5 py-3">
                <div class="flex items-center gap-2 flex-wrap">
                  <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium"
                        [class]="feeStatusBadgeClass(member)"
                        [title]="feeStatusTooltip(member)">
                    @switch (feeStatusKind(member)) {
                      @case ('paid') {
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/></svg>
                      }
                      @case ('partial') {
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" stroke-width="2"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3"/></svg>
                      }
                      @case ('pending') {
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" stroke-width="2"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3"/></svg>
                      }
                    }
                    {{ feeStatusLabel(member) }}
                  </span>
                  @if (member.status === 'Active' && (member.currentPeriodTotalPaid ?? 0) > 0) {
                    <span class="text-xs text-gray-500"
                          [title]="(member.currentPeriodExpected ?? 0) > 0
                            ? 'of Rs. ' + (member.currentPeriodExpected | number:'1.2-2')
                            : ''">
                      Rs. {{ member.currentPeriodTotalPaid | number:'1.2-2' }}
                      @if ((member.currentPeriodPaymentCount ?? 0) > 1) {
                        <span class="text-gray-400">· {{ member.currentPeriodPaymentCount }} pmts</span>
                      }
                    </span>
                  }
                  @if (member.status === 'Active') {
                    <button *appHasPermission="301" type="button" (click)="openPayForMember(member)"
                            [title]="feeStatusTooltip(member)"
                            class="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium border transition-colors"
                            [class]="payButtonClass(member)">
                      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"/></svg>
                      {{ payButtonLabel(member) }}
                    </button>
                  }
                </div>
              </td>
              <td class="px-5 py-3">
                <div class="flex items-center justify-end gap-1">
                  @if (isAdmin() && isMissingCurrentBu(member)) {
                    <button type="button"
                            (click)="confirmAssign(member)"
                            [disabled]="rowBusyId === member.id"
                            [title]="'Add ' + member.fullName + ' to ' + (selectedBuName() ?? 'this committee')"
                            class="inline-flex items-center gap-1 px-2.5 py-1 mr-1 rounded-md text-xs font-semibold bg-blue-600 text-white hover:bg-blue-700 transition-colors disabled:opacity-60 disabled:cursor-not-allowed">
                      @if (rowBusyId === member.id && isAssigning) {
                        <app-spinner size="sm" colour="white"></app-spinner>
                      } @else {
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"/>
                        </svg>
                      }
                      Assign
                    </button>
                  }
                  <button (click)="openMemberDetail(member)"
                          title="Quick view"
                          [disabled]="rowBusyId === member.id"
                          class="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors disabled:opacity-50">
                    @if (rowBusyId === member.id) {
                      <app-spinner size="sm" colour="current"></app-spinner>
                    } @else {
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                      </svg>
                    }
                  </button>
                  <button *appHasPermission="203" (click)="openEdit(member)"
                          title="Edit"
                          class="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                    </svg>
                  </button>
                  <button *appHasPermission="204" (click)="confirmDelete(member)"
                          title="Delete"
                          class="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          }
          @if (members.length === 0) {
            <tr>
              <td colspan="7" class="px-5 py-16 text-center">
                <div class="flex flex-col items-center gap-3 text-gray-400">
                  <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
                  </svg>
                  <p class="text-sm">No members found</p>
                  <button *appHasPermission="201" (click)="openCreate()"
                          class="text-blue-600 text-sm hover:underline">
                    Add the first member
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (totalPages > 1) {
      <div class="px-5 py-4 border-t border-gray-100 flex items-center justify-between flex-wrap gap-3">
        <p class="text-sm text-gray-500">
          Showing {{ startIndex }} to {{ endIndex }} of {{ totalCount }} members
        </p>
        <div class="flex items-center gap-1">
          <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1"
                  class="px-3 py-1.5 text-sm border border-gray-300 rounded-lg disabled:opacity-40 hover:bg-gray-50 transition-colors">
            Previous
          </button>
          @for (page of pages; track page) {
            <button (click)="changePage(page)"
                    [class]="currentPage === page
                      ? 'px-3 py-1.5 text-sm bg-blue-600 text-white rounded-lg'
                      : 'px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors'">
              {{ page }}
            </button>
          }
          <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages"
                  class="px-3 py-1.5 text-sm border border-gray-300 rounded-lg disabled:opacity-40 hover:bg-gray-50 transition-colors">
            Next
          </button>
        </div>
      </div>
    }
  </div>
}

}

<!-- Create/Edit modal -->
<app-member-form
  [open]="showFormModal"
  [member]="editingMember"
  (closed)="closeForm()"
  (saved)="onMemberSaved($event)"
  (userProvisioned)="onMemberFormUserProvisioned($event)">
</app-member-form>

<!-- Temp password / account-ready modal -->
@if (tempPasswordModal.open) {
  <app-temp-password-modal
    [password]="tempPasswordModal.password"
    [username]="tempPasswordModal.username"
    [phone]="tempPasswordModal.phone"
    [email]="tempPasswordModal.email"
    [committeeName]="committeeName()"
    [credentialsDelivered]="tempPasswordModal.credentialsDelivered"
    [heading]="tempPasswordModal.heading"
    [subheading]="tempPasswordModal.subheading"
    [footer]="tempPasswordModal.footer"
    (close)="closeTempPasswordModal()">
  </app-temp-password-modal>
}

<!-- Manage roles modal -->
@if (manageRolesModal.open && manageRolesModal.member?.userAccount) {
  <app-manage-roles-modal
    [currentRoleCodes]="manageRolesModal.member!.userAccount!.roleCodes || []"
    (close)="closeManageRoles()"
    (save)="onRolesSaved($event)">
  </app-manage-roles-modal>
}

<!-- Manage committees modal (Super Admin only) -->
@if (manageCommitteesModal.open && manageCommitteesModal.member) {
  <app-manage-committees-modal
    [currentBusinessUnitIds]="manageCommitteesModal.member!.businessUnitIds || []"
    (close)="closeManageCommittees()"
    (save)="onCommitteesSaved($event)">
  </app-manage-committees-modal>
}

<!-- Bulk assign modal -->
<app-bulk-assign-bu-modal
  [open]="bulkModalOpen()"
  [memberIds]="selectedMemberIds()"
  [defaultAction]="bulkModalAction()"
  (closed)="closeBulkModal()"
  (saved)="onBulkSaved($event)">
</app-bulk-assign-bu-modal>

<!-- Single payment modal (prefilled from row) -->
<app-payment-form
  [open]="showPayModal"
  [payment]="null"
  [initialMember]="payInitialMember"
  [initialMonth]="payInitialMonth"
  [initialYear]="payInitialYear"
  [initialAmount]="payInitialAmount"
  [lockMember]="true"
  (closed)="closePayModal()"
  (saved)="onPaymentSaved($event)">
</app-payment-form>

<!-- Bulk pay modal -->
<app-bulk-pay-modal
  [open]="showBulkPayModal"
  [members]="bulkPayMembers"
  [month]="feeMonth"
  [year]="feeYear"
  (closed)="closeBulkPayModal()"
  (saved)="onBulkPaySaved($event)">
</app-bulk-pay-modal>

<!-- Quick view drawer -->
<app-member-quick-view-drawer
  [open]="showQuickView"
  [member]="quickViewMember"
  [selectedBuId]="selectedBusinessUnitId()"
  [busy]="drawerBusy"
  (closed)="closeQuickView()"
  (recordPayment)="openPayForMember($event)"
  (editMember)="openEdit($event)"
  (selectHousehold)="selectHousehold($event)"
  (createUserAccount)="createUserAccount($event)"
  (resetPassword)="resetMemberPassword($event)"
  (manageRoles)="openManageRoles($event)"
  (manageBusinessUnits)="openManageBusinessUnits($event)"
  (invite)="inviteMember($event)"
  (deactivateUser)="deactivateMemberUser($event)"
  (openFullProfile)="openFullProfile($event)">
</app-member-quick-view-drawer>

<!-- Reset password confirmation -->
@if (resetConfirmMember !== null) {
  <div class="fixed inset-0 z-[60] flex items-center justify-center p-4">
    <div class="absolute inset-0 bg-gray-900/60 backdrop-blur-sm"></div>
    <div class="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-5 sm:p-6">
      <div class="flex items-start gap-3 mb-3">
        <div class="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
          <svg class="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
          </svg>
        </div>
        <div class="flex-1">
          <h3 class="text-lg font-semibold text-gray-900 mb-1">Reset password?</h3>
          <p class="text-sm text-gray-600 leading-relaxed">
            This will immediately invalidate <strong>{{ resetConfirmMember.fullName }}</strong>'s
            current password. They will receive a new temporary password by email/SMS and must
            change it on next login.
          </p>
        </div>
      </div>
      <div class="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-2 sm:gap-3 mt-5">
        <button (click)="cancelResetPassword()" [disabled]="isResetting"
                class="w-full sm:w-auto max-md:tap-target px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50">
          Cancel
        </button>
        <button (click)="confirmResetPassword()" [disabled]="isResetting"
                class="w-full sm:w-auto max-md:tap-target inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors disabled:opacity-50">
          <app-spinner *ngIf="isResetting" size="xs" colour="white"></app-spinner>
          {{ isResetting ? 'Resetting...' : 'Reset password' }}
        </button>
      </div>
    </div>
  </div>
}

<!-- Delete confirmation -->
<app-confirm-dialog
  [open]="pendingDeleteMember !== null"
  title="Delete this member?"
  message="The member will be marked as deleted. Their payment history stays intact and an admin can restore the record if needed."
  [entityName]="pendingDeleteMemberName()"
  confirmLabel="Delete member"
  loadingLabel="Deleting..."
  [loading]="isDeleting"
  (confirm)="performDelete()"
  (cancel)="cancelDelete()">
</app-confirm-dialog>

<!-- Assign-to-committee confirmation -->
<app-confirm-dialog
  [open]="pendingAssignMember !== null"
  variant="info"
  [title]="'Assign to ' + (selectedBuName() ?? 'this committee') + '?'"
  [message]="'Add this member to the ' + (selectedBuName() ?? 'current') + ' committee.'"
  [entityName]="pendingAssignMemberName()"
  confirmLabel="Assign"
  loadingLabel="Assigning..."
  [loading]="isAssigning"
  (confirm)="performAssign()"
  (cancel)="cancelAssign()">
</app-confirm-dialog>
